import each from 'lodash/each';

export const getScoreThemeColor = (score: number) => {
  switch (true) {
    case score < 5:
      return 'success.main';
    case score >= 5 && score <= 6:
      return 'warning.main';
    default:
      return 'error.main';
  }
};

export const getMillionsShort = (value: number) =>
  `${(value / 1000000).toFixed(2)} млн`;

export const makeTransition = (
  properties: string[],
  opt?: { foo?: string; duration?: string }
) => {
  let transition = '';

  const foo = opt?.foo || 'cubic-bezier(0.4, 0, 0.2, 1)';
  const dur = opt?.duration || '450ms';

  each(properties, (prop, i) => {
    transition += `${prop} ${foo} ${dur} 0ms${
      i === properties.length - 1 ? '' : ','
    }`;
  });

  return transition;
};
